let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5IN5I")).then(() => parcelRequire('7x2bx'));